import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncSupportParishDetailsMobile({ ...rest }) {
  const AsyncLoad = loadable(() => import("../supportParishDetailsMobilePage"));
  console.log("Loading", AsyncSupportParishDetailsMobile.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncSupportParishDetailsMobile;
